module.exports = __webpack_public_path__ + "static/img/banner01.9088ede.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner01.png
// module id = Bop5
// module chunks = 26